module.exports = __webpack_public_path__ + "img/back.b65dca55.png";